import config from "../config/config.json";

interface BuildStaticMapUrlOptions {
  width: number;
  height: number;
  showMarker: boolean;
  markerColor: string;
}

export function buildStaticMapUrl(
  lat: number,
  lng: number,
  { width, height, showMarker, markerColor }: BuildStaticMapUrlOptions = {
    width: 600,
    height: 300,
    showMarker: false,
    markerColor: "red",
  }
) {
  const dimensions = `${width}x${height}`;
  const markerParams = showMarker
    ? `markers=color:${markerColor}%7C${lat},${lng}`
    : "";
  const googleStaticMapsApiKey = config.apiKeys.googleStaticMapsApiKey;
  return `https://maps.googleapis.com/maps/api/staticmap?center=${lat},${lng}&zoom=13&size=${dimensions}&maptype=roadmap&${markerParams}&key=${googleStaticMapsApiKey}`;
}
